import React from "react";
import PropTypes from "prop-types";
import PriceRange from "../../../components/common/card/price-range";

const DocumentBodyTotalCell = ({
    total,
    symbol,
    netPrice,
    discountPrice,
    purchasePrice,
    showMargin,
}) => {
    const normalizedTotal = Number(total);
    const formattedTotal = Number.isFinite(normalizedTotal)
        ? normalizedTotal.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        : total;
    const normalizedNetPrice = Number(netPrice ?? discountPrice);
    const normalizedPurchasePrice = Number(purchasePrice);
    const hasPriceRange = Number.isFinite(normalizedNetPrice)
        && Number.isFinite(normalizedPurchasePrice)
        && normalizedNetPrice > 0
        && normalizedPurchasePrice > 0;

    return (
        <div className="flex w-full items-center ">
            <span className="truncate text-sm font-semibold text-gray-900">
                {formattedTotal}
                {symbol ? ` ${symbol}` : ""}
            </span>
            {hasPriceRange && (
                <div className="mt-1 flex items-center">
                    <PriceRange
                        symbol={symbol ?? ""}
                        purchasePrice={normalizedPurchasePrice || false}
                        price={normalizedNetPrice}
                        isLeft
                        showMargin={showMargin}
                    />
                </div>
            )}
        </div>
    );
};

DocumentBodyTotalCell.propTypes = {
    total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    symbol: PropTypes.string,
    netPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    discountPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    purchasePrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    showMargin: PropTypes.bool,
};

DocumentBodyTotalCell.defaultProps = {
    total: 0,
    symbol: "",
    netPrice: undefined,
    discountPrice: 0,
    purchasePrice: false,
    showMargin: true,
};

export default DocumentBodyTotalCell;

